import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAnalyticsModule, DEBUG_MODE } from '@angular/fire/compat/analytics';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { RouterModule } from '@angular/router';
import { KeycloakAngularModule, KeycloakBearerInterceptor, KeycloakService } from '@inoventoryapps/keycloak-angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import Aura from '@primeng/themes/aura';
import { NgxUiLoaderConfig, NgxUiLoaderHttpModule, NgxUiLoaderModule } from 'ngx-ui-loader';
import { providePrimeNG } from 'primeng/config';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CacheInterceptor } from './cache.interceptor';
import { RoleComponent } from './components/role/role.component';
import { Encryption2Interceptor } from './encryption2.interceptor';
import { initializeKeycloak } from './init/keycloak-init.factory';
import { HeadersInterceptor } from './interceptor/headers.interceptor';
import { NormalizeStringPipe } from './pipe/normalist-string.pipe';
import { SharedModule } from './shared/shared.module';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
    bgsSize: 0,
    fgsSize: 0,
    hasProgressBar: false,
    logoUrl: 'https://cdn.lokos.in/lokos-in/assets/LokOS-Circle-Animation.gif',
    overlayColor: 'transparent'
};

export function HttpLoaderFactory (http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@NgModule({
    declarations: [
        AppComponent,
        RoleComponent
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        AppRoutingModule,
        BrowserAnimationsModule,
        BrowserModule,
        NgxUiLoaderHttpModule.forRoot({
            showForeground: true,
            excludeRegexp: [
                'vault/profile',
                'vault/.*member',
            ]
        }),
        NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
        AngularFireModule.initializeApp(environment.firebaseConfig),
        AngularFirestoreModule,
        RouterModule,
        SharedModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        KeycloakAngularModule,
        AngularFireAnalyticsModule
    ],
    providers: [
        provideAnimationsAsync(),
        providePrimeNG({ theme: { preset: Aura } }),
        {
            provide: APP_INITIALIZER,
            useFactory: initializeKeycloak,
            multi: true,
            deps: [KeycloakService]
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: KeycloakBearerInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HeadersInterceptor,
            multi: true, // Existing interceptor
        },
        {
            multi: true,
            provide: HTTP_INTERCEPTORS,
            useClass: CacheInterceptor
        },
        {
            multi: true,
            provide: HTTP_INTERCEPTORS,
            useClass: Encryption2Interceptor
        },
        DatePipe,
        NormalizeStringPipe,
        { provide: DEBUG_MODE, useValue: true },
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule { }
